<div class="quick-order-actions">
  <div
    class="button-wrapper"
    matTooltip="{{ 'buttonTooltip.quickOrder.deleteAllButton' | cxTranslate }}"
    [matTooltipPosition]="'below'"
    [matTooltipClass]="'button-tooltip'"
    aria-label="displays a tooltip in bottom"
    [matTooltipDisabled]="!deviceDetectorService.isDesktop()"
  >
    <button
      class="btn tertiary-btn"
      type="button"
      (click)="clearAll()"
      [attr.disabled]="entries.length === 0 ? 'disabled' : null"
    >
      <mat-icon svgIcon="deletecart"></mat-icon>
    </button>
  </div>
  <div
    class="button-wrapper"
    matTooltip="{{ 'buttonTooltip.addToCart.title' | cxTranslate }}"
    [matTooltipPosition]="'below'"
    [matTooltipClass]="'button-tooltip'"
    aria-label="displays a tooltip in bottom"
    [matTooltipDisabled]="!deviceDetectorService.isDesktop()"
  >
    <button
      class="btn btn-primary"
      type="button"
      (click)="backOrderCheck(entries)"
      [attr.disabled]="
        cartDisable || !hasAtLeastOneDealerPrice(entries) || entries.length === 0 || showSrp ? 'disabled' : null
      "
      [ngClass]="{
        rotating: addToCartInprogress
      }"
    >
      <ng-container *ngIf="!addToCartInprogress; else showSpinner">
        <mat-icon svgIcon="add-to-cart"></mat-icon>
      </ng-container>
      <ng-template #showSpinner></ng-template>
    </button>
  </div>
</div>
<div class="quick-order-entries" *ngIf="entries.length > 0">
  <div class="quick-order-entry" *ngFor="let entry of entries; let index = index">
    <button type="button" class="close" aria-label="Close" (click)="deleteEntry(index)">
      <mat-icon
        matTooltip="{{ 'buttonTooltip.quickOrder.deleteEntry' | cxTranslate }}"
        [matTooltipPosition]="'below'"
        matTooltipClass="icon-tooltip"
        aria-label="displays a tooltip in bottom"
        svgIcon="x-icon"
      ></mat-icon>
    </button>
    <mat-form-field appearance="outline">
      <mat-label>{{ 'cart.quickOrder.queryProduct.input' | cxTranslate }}</mat-label>
      <input
        matInput
        placeholder="{{ 'cart.quickOrder.queryProduct.placeholder' | cxTranslate }}"
        [value]="entry.code"
        disabled
      />
    </mat-form-field>
    <div class="entry">
      <div class="image">
        <a class="cx-link" [routerLink]="{ cxRoute: 'product', params: entry } | cxUrl">
          <cx-media
            *ngIf="entry?.images; else noImage"
            [container]="getImageRendition((entry?.images)[0])"
            format="product"
            [class.is-missing-fish]="businessType === 'fish'"
          ></cx-media>
          <ng-template #noImage>
            <cx-media class="cx-no-image is-missing" [class.is-missing-fish]="businessType === 'fish'"></cx-media>
          </ng-template>
        </a>
      </div>
      <div class="entry-info">
        <div class="code">
          {{ entry.code }}
          <ng-container *ngIf="entry?.manualAllocation; else productStock">
            <span class="no-stock">
              <div>{{ 'product.noStock' | cxTranslate }}</div>
            </span>
          </ng-container>
          <ng-template #productStock>
            <span class="in-stock" *ngIf="entry?.inStockFlag === true">
              <div>{{ 'product.inStock' | cxTranslate }}</div>
            </span>
            <span class="no-stock" *ngIf="entry?.inStockFlag === false">
              <div>{{ 'product.noStock' | cxTranslate }}</div>
            </span>
          </ng-template>
        </div>
        <div class="name" [innerHTML]="entry.name"></div>
        <div
          class="global-variant"
          [class.ofBy-present]="entry?.replacementOf && entry?.replacedBy"
          *ngIf="entry?.superCategories"
        >
          <ng-container
            *ngFor="let variant of checkVariant(entry?.superCategories); let index = index; let last = last"
          >
            <ng-container *ngIf="!last; else lastItem"
              >{{ variant.parentCategoryName }}: {{ variant.name }};
            </ng-container>
            <ng-template #lastItem>{{ variant.parentCategoryName }}: {{ variant.name }}</ng-template>
          </ng-container>
        </div>

        <!-- TABLET MODE ONLY-->
        <div
          class="replacement-tablet-only"
          *ngIf="entry?.replacementOf"
          [class.mt-auto]="entry?.replacementOf && entry?.replacedBy"
        >
          <div class="replacement-of">
            <div class="label">{{ 'cart.quickOrder.queryProduct.replacementOf' | cxTranslate }}</div>
            <div class="value">
              <a [routerLink]="{ cxRoute: 'product', params: entry.replacementOf } | cxUrl">{{
                entry?.replacementOf?.code
              }}</a>
            </div>
          </div>
          <div class="replaced-by" *ngIf="!entry?.replacementOf && entry?.replacedBy">
            <div class="label">{{ 'cart.quickOrder.queryProduct.replacedBy' | cxTranslate }}</div>
            <div class="value">
              <a [routerLink]="{ cxRoute: 'product', params: entry.replacedBy } | cxUrl">
                {{ entry?.replacedBy?.code }}
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="entry-price" [ngClass]="{ 'entry-with-notify-me': entry?.notifyMe }">
        <div class="entry-price-wrapper">
          <div class="dealer-price">
            <div class="label">{{ 'cart.cartItem.itemPrice' | cxTranslate }}</div>
            <div class="value" *ngIf="!showSrp">
              <div class="spinner-shimano-wrapper-dp" *ngIf="!dealerPrice(entry.code); else dealerPriceReady">
                <ng-container *ngIf="tooltipIconConfig$ | async as tooltipIconConfig">
                  <div class="spinner-shimano spinner-shimano-mr" *ngIf="hasDealerPriceOf[entry.code]">
                    <div></div>
                  </div>
                  <div
                    class="no-dealer-price no-dealer-price-cs-cm"
                    *ngIf="!hasDealerPriceOf[entry.code] && !tooltipIconConfig?.enabled; else noDealerPriceTooltip"
                  ></div>
                  <ng-template #noDealerPriceTooltip>
                    <app-tooltip-icon
                      *ngIf="!hasDealerPriceOf[entry.code] && tooltipIconConfig?.enabled"
                      [noDealerPriceIcon]="tooltipIconConfig?.noDealerPriceIcon"
                      dealerPriceIconContainerClass="no-dealer-price-cs-cm"
                      placement="bottom-right"
                      [tooltipContent]="'tooltip.hasNoDealerPrice' | cxTranslate"
                      [closeOnScroll]="tooltipIconConfig?.closeOnScroll"
                    ></app-tooltip-icon>
                  </ng-template>
                </ng-container>
              </div>
              <ng-template #dealerPriceReady>
                {{ dealerPrice(entry.code) }}
                <span class="d-block" *ngIf="showGstExclusive$ | async">{{
                  'cart.cartItem.gstExclusive' | cxTranslate
                }}</span>
              </ng-template>
            </div>
          </div>
          <div class="quantity">
            <input
              #quickOrderInput
              class="cx-counter-value js-quantity"
              type="number"
              [min]="min"
              [max]="max"
              [step]="step"
              [value]="entry.qty"
              (change)="
                quickOrderInput.value === '' || quickOrderInput.value < 0 ? (quickOrderInput.value = 1) : true;
                updateCount(index, quickOrderInput.value, entry)
              "
              (blur)="
                quickOrderInput.value === '' || quickOrderInput.value < 0 ? (quickOrderInput.value = 1) : true;
                updateCount(index, quickOrderInput.value, entry)
              "
              (keypress)="numberOnly($event)"
              (input)="onInput(quickOrderInput.value)"
              [class.invalid]="entry.isMoqError"
              oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); this.value = this.value.replace(/^[0]+/g,'')"
              maxlength="3"
              [attr.disabled]="!dealerPriceValue(entry.code) ? 'disabled' : null"
            />
            <mat-error
              *ngIf="entry.isMoqError"
              [class.gst-exclusive]="dealerPriceValue(entry.code) && showGstExclusive$ | async"
            >
              {{ 'moq.inlineMessage' | cxTranslate : { moq: entry.minOrderQuantity } }}
            </mat-error>
          </div>
          <div class="total">
            <div class="label">{{ 'cart.cartItem.total' | cxTranslate }}</div>
            <div class="value" *ngIf="!showSrp">
              <div class="spinner-shimano-wrapper-dp" *ngIf="!dealerPrice(entry.code); else dealerTotalReady">
                <div class="spinner-shimano spinner-shimano-mr" *ngIf="hasDealerPriceOf[entry.code]">
                  <div></div>
                </div>
                <div class="no-dealer-price no-dealer-price-cs-cm" *ngIf="!hasDealerPriceOf[entry.code]"></div>
              </div>
              <ng-template #dealerTotalReady>
                {{ entry.qty * dealerPriceValue(entry.code) | mycurrency }}
                <span class="d-block" *ngIf="showGstExclusive$ | async">{{
                  'cart.cartItem.gstExclusive' | cxTranslate
                }}</span>
              </ng-template>
            </div>
          </div>
        </div>

        <!-- TABLET MODE ONLY-->
        <div class="replacement-tablet-only" [class.mt-auto]="entry?.replacementOf && entry?.replacedBy">
          <div class="replaced-by" *ngIf="entry?.replacedBy">
            <div class="label">{{ 'cart.quickOrder.queryProduct.replacedBy' | cxTranslate }}</div>
            <div class="value">
              <a [routerLink]="{ cxRoute: 'product', params: entry?.replacedBy } | cxUrl">{{
                entry?.replacedBy?.code
              }}</a>
            </div>
          </div>
        </div>
      </div>

      <div
        class="replacement-wrapper"
        [class.ofBy-present]="entry?.replacementOf && entry?.replacedBy"
        [ngClass]="{ 'replacement-with-notify-me': entry?.notifyMe }"
      >
        <div class="replacement-of" *ngIf="entry?.replacementOf">
          <div class="label">{{ 'cart.quickOrder.queryProduct.replacementOf' | cxTranslate }}</div>
          <div class="value">
            <a [routerLink]="{ cxRoute: 'product', params: entry?.replacementOf } | cxUrl">{{
              entry?.replacementOf?.code
            }}</a>
          </div>
        </div>
        <div class="replaced-by" *ngIf="entry?.replacedBy">
          <div class="label">{{ 'cart.quickOrder.queryProduct.replacedBy' | cxTranslate }}</div>
          <div class="value">
            <a [routerLink]="{ cxRoute: 'product', params: entry?.replacedBy } | cxUrl">{{
              entry?.replacedBy?.code
            }}</a>
          </div>
        </div>
      </div>
      <div class="notify-me-wrapper" *ngIf="entry.notifyMe">
        <app-notify-me [productCode]="entry.code"></app-notify-me>
      </div>
    </div>
  </div>
</div>
<div class="quick-order-form" *ngIf="entries.length < 25">
  <div class="entry-input" [ngClass]="{ 'error-text': queryProduct.invalid }">
    <form [formGroup]="form">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'cart.quickOrder.queryProduct.input' | cxTranslate }}</mat-label>
        <input
          matInput
          placeholder="{{ 'cart.quickOrder.queryProduct.placeholder' | cxTranslate }}"
          formControlName="queryProduct"
          name="queryProduct"
          [formControl]="queryProduct"
          (focusout)="onKeyUp($event)"
          (keydown.enter)="$event.target.blur(); (false)"
          #skuItemNumber
        />
        <mat-error *ngIf="queryProduct.invalid">{{ errorText }}</mat-error>
      </mat-form-field>
    </form>
  </div>
</div>
